/* eslint-disable @typescript-eslint/no-use-before-define */
import { createAction } from '@reduxjs/toolkit'
import { all, call, put, takeLatest } from 'redux-saga/effects'
import { Venue } from 'src/common/common.interface'
import { getAllVenues } from 'src/api/venue'

import { venueAction } from './venue.slice'

export function* getAllVenuesSaga() {
  try {
    const res: Venue[] = yield call(getAllVenues)
    yield put(venueAction.setVenuesData(res))
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('error getAllVenuesSaga', error)
  } finally {
    yield put(venueAction.setIsLoadingGetVenues(false))
  }
}

export const venueActionSaga = {
  getAllVenues: createAction('venueActionSaga/getAllVenues')
}

export default [
  function* fetchWatcher() {
    yield all([takeLatest(venueActionSaga.getAllVenues, getAllVenuesSaga)])
  }
]
